import { Box } from "@mui/material";
import React from "react";
import _ from "lodash";

import { useOnboardingState } from "./OnboardingProvider";
import { StyledLoginCard, StyledWarningLink } from "./Onboarding.styles";
import { useIntl } from "react-intl";
import { apiUrl } from "features/configure";

export default function Login() {
  const { prevStep, connectorList, connectWallet, connectGoogle, ecosystem } =
    useOnboardingState();
  const { formatMessage } = useIntl();
  const ecoSystemMapping = {
    EVM: {
      name: "Ethereum",
      logo: require("assets/img/evm.svg").default,
    },
    Solana: {
      name: "Solana",
      logo: require("assets/img/solana.svg").default,
    },
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        pt: "125px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#FAFAFD",
        position: "relative",
      }}
    >
      <Box
        onClick={prevStep}
        sx={{
          position: "absolute",
          top: 24,
          left: 24,
          zIndex: 10,
          color: "#A5A5A5",
          cursor: "pointer",
        }}
      >
        <i className="meta-crm-icon-ic_arrowBackward font-size-36" />
      </Box>
      <img src={require("assets/img/onboardingLogo.png")} alt="MetaCRM Logo" />
      <Box color="#383538" fontSize="24px" fontWeight={700} mt="8px">
        {formatMessage({ id: "global.connectAccount.title" })}
      </Box>
      <Box color="#777" fontSize="14px" mb="16px" mt={"4px"}>
        {formatMessage({ id: "global.connectAccount.subtitle" })}
      </Box>
      <Box color="#777" fontSize="12px" mb="16px" className="item-flex">
        {formatMessage({ id: "login.wallet.builtWith" })}
        <img
          src={ecoSystemMapping[ecosystem]?.logo}
          width={20}
          height={20}
          style={{ margin: "0 4px" }}
          alt={ecosystem}
        />
        <Box color="#383538">{ecoSystemMapping[ecosystem]?.name}</Box>
      </Box>

      <StyledLoginCard onClick={connectGoogle}>
        <img
          src={require("assets/img/google.png")}
          style={{
            width: 36,
            height: 36,
            borderRadius: "8px",
            objectFit: "cover",
          }}
          alt={`gmail logo`}
        />
        <Box ml="12px">
          {formatMessage({ id: "global.connectAccount.continuetWithGoogle" })}
        </Box>
      </StyledLoginCard>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: "12px",
          width: "400px",
        }}
      >
        <Box sx={{ width: "100%", height: "1px", bgcolor: "#E6E6E6" }} />
        <Box mx="8px" color="#777">
          {formatMessage({ id: "global.commonWord.or" })}
        </Box>
        <Box sx={{ width: "100%", height: "1px", bgcolor: "#E6E6E6" }} />
      </Box>
      {connectorList.map((connector) => (
        <StyledLoginCard
          key={connector.name}
          onClick={() => connectWallet(connector)}
        >
          <img
            src={connector.img}
            style={{ width: 36, height: 36, borderRadius: "8px" }}
            alt={`${connector.name} logo`}
          />
          <Box ml="12px">{connector.name}</Box>
        </StyledLoginCard>
      ))}

      <Box color={"#777"} fontSize="12px" display="flex" gap="2px" mt="18px">
        <span>
          {formatMessage({ id: "global.connectAccount.description" })}
        </span>
        <StyledWarningLink
          href="https://metacrm.inc/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
        >
          {formatMessage({ id: "global.commonWord.terms" })}
        </StyledWarningLink>
        &{"  "}
        <StyledWarningLink
          href="https://metacrm.inc/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
        >
          {formatMessage({ id: "global.commonWord.privacyPolicy" })}
        </StyledWarningLink>
      </Box>
    </Box>
  );
}
